import { Injectable } from '@angular/core';
import { BehaviorSubject } from "rxjs";
import { msalDataInterface, UserDataInterface } from "../models/user-data";
import { environment } from "../../../environments/environment";
import { mockUser } from "../../../environments/environment.local";
import { HttpClient } from "@angular/common/http";
import { ApiService } from "@core/services/api.service";

@Injectable({
    providedIn: 'root'
})
export class UserDataService {
    currentUserData$ = new BehaviorSubject<UserDataInterface>({} as UserDataInterface);
    msalProfile: msalDataInterface | undefined;
    profileReady$ = new BehaviorSubject<boolean>(false);


    constructor(
        private http: HttpClient,
        private api: ApiService,
    ) {
        this.getUserProfile(environment.apiConfig.uri);

    }
    getUserProfile(url: string) {
        if (!environment.local && !environment.dev) {
            this.http.get(url)
                .subscribe(profile => {
                    this.msalProfile = profile as msalDataInterface;
                    this.sendUserDataToBackend();
                });
        } else {
            this.msalProfile = mockUser;
            this.sendUserDataToBackend();
        }

    }

    sendUserDataToBackend() {
        if (this.msalProfile) {
            const userData = {
                "user_id": null,
                "guid": this.msalProfile.id,
                "displayname": this.msalProfile.displayName,
                "givenname": this.msalProfile.givenName,
                "jobtitle": this.msalProfile.jobTitle,
                "mail": this.msalProfile.mail,
                "mobilephone": null,
                "officelocation": this.msalProfile.officeLocation,
                "preferredlanguage": this.msalProfile.preferredLanguage || 'EN',
                "surname": this.msalProfile.surname,
                "userprincipalname": this.msalProfile.userPrincipalName,
                "lang": '',
                "profile": '',
            }
            this.api.sendUser(userData).subscribe(response => {
                //TODO: Error handling
                this.currentUserData$.next(response as UserDataInterface);
                this.profileReady$.next(true);
                // this.userSettings = {
                //   lang: this.currentUserData$.getValue().lang,
                //   profile: this.currentUserData$.getValue().profile,
                // }
            });
        }
    }
    get userProfile() {
        return this.currentUserData$.asObservable();
    }

    get isProfileReady() {
        return this.profileReady$.asObservable();
    }

    setUserData(userData: UserDataInterface) {
        this.currentUserData$.next(userData);
    }
}
